import BaseListPresenter from "../../../base/BaseListPresenter";

class EmOverTimePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    const getcurrent = this.view.getcurrent();
    this.limit = 10;
    this.where = { supervisor: getcurrent };
    this.search = {};
    this.filter = {};
    this.include = ["employee"];
    this.keys = []; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  formatDateTime(dateStr) {
    return new Date(dateStr).toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }

  async GeneratePDF(user) {
    const objects = await this.findObjectUseCase.execute(
      this.view.getCollectionName(),
      this.createQuery()
    );
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printData = `
        <html>
        <head>
          <style>

            @page {
                size: auto;   /* auto is the initial value */
                margin: 0;     /* this affects the margin in the printer settings */
                visibility: hidden;
            }

            body {
              margin: 2rem
            }

            table {
              border-collapse: collapse;
              width: 100%;
              margin-top: 1rem
            }
            th, td {
              border: 1px solid #dddddd;
              text-align: left;
              padding: 8px;
            }
            th {
              background-color: #f2f2f2;
            }
          </style>
        </head>
          <body>
          <img src="${"/BI.png"}" width="100%" height="130" />
            <table>
              <thead>
                <tr>
                <th>EMPLOYEE</th>
                <th>TIME IN</th>
                <th>TIME OUT</th>
                <th>DURATION</th>
                </tr>
              </thead>
             <tbody>
  ${objects
    .map((item) => {
      const employeeName = `${item.employee.Firstname || ""} ${
        item.employee.Middlename || ""
      } ${item.employee.surname || ""}`;
      return `
        <tr>
          <td>${employeeName}</td>
          <td>${this.formatDateTime(item.startTime)}</td>
          <td>${this.formatDateTime(item.endTime)}</td>
          <td>${item.duration}</td>
        </tr>
      `;
    })
    .join("")}
</tbody>
            </table>
          </body>
        </html>
      `;

    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(printData);
    iframe.contentWindow.document.close();

    iframe.onload = () => {
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  }

  async GenerateExcel() {
    const objects = await this.findObjectUseCase.execute(
      this.view.getCollectionName(),
      this.createQuery()
    );
    let csvContent = "EMPLOYEE,TIME IN,TIME OUT,DURATION\n"; // CSV header

    objects.forEach((item) => {
      const employeeName = `${item.employee.Firstname || ""} ${
        item.employee.Middlename || ""
      } ${item.employee.surname || ""}`;
      const employee = this.wrapInQuotes(employeeName); // Assuming `user` is a property of `item`
      const timeIn = this.wrapInQuotes(this.formatDateTime(item.startTime));
      const timeOut = this.wrapInQuotes(this.formatDateTime(item.endTime));
      const duration = this.wrapInQuotes(item.duration);

      csvContent += `${employee},${timeIn},${timeOut},${duration}\n`;
    });

    // Create a blob from CSV content
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a link element and trigger download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Overtime Report-${new Date().toISOString().split("T")[0]}.csv`
    );
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  // Helper function to wrap values in quotes if necessary
  wrapInQuotes(value) {
    // Convert to string and check if it contains a comma or new line
    const strValue = String(value);
    if (strValue.includes(",") || strValue.includes("\n")) {
      return `"${strValue.replace(/"/g, '""')}"`; // Wrap in quotes and escape any existing quotes
    }
    return strValue;
  }
}
export default EmOverTimePresenter;
